/*eslint-disable */
import React, { PureComponent } from "react";
import Sidebar from "./sidebar";
import Header from "./header";
import * as axios from "axios";
import qs from 'qs';
import { connect } from "react-redux";
import { logout } from "../../redux/actions/userAction";
import { permissions } from "../../redux/actions/permissionAction";
import { autoLogin } from "../../redux/actions/userAction";
import { Dimmer, Loader } from "semantic-ui-react";

class Layout extends PureComponent {

  state = {
    isAutoLogin: true,
    autoLoginText: 'Please wait...',
  }
  componentWillMount() {
    this.checkTokenExp();
  }

  componentDidMount() {
    let queryString = qs.parse(window.location.search)
    let userKey = queryString["userKey"] || queryString["?userKey"] || null;
    let globalAccessToken = queryString["token"] || queryString["?token"] || null;
    if (userKey != null && globalAccessToken != null) {
      this.setState({
        isAutoLogin: false
      })
      this.props.autoLogin(globalAccessToken, userKey)
        .then((res) => {
          if (res.customerNo == 1158) {
            setTimeout(() => {
              window.location.href = "/shipment";
            }, 500);
          } else {
            setTimeout(() => {
              window.location.href = "/shipment";
            }, 500);
          }
        })
    } else {
      this.setState({
        isAutoLogin: false
      })
    }
  }

  componentWillUpdate() {
    // this.tokenValidity();
    this.checkTokenExp();
  }

  checkTokenExp = () => {
    let authToken = this.props.auth.token;
    if (authToken) {
      let jsonPayload = this.parseJwt(authToken);
      let expTime = jsonPayload.exp;
      let currentTime = Math.floor(Date.now() / 1000);
      if (expTime < currentTime) {
        this.props.logout();
      } else {
        this.props.permissions(this.props.auth.role, this.props.auth.token)
      }
    }
  };

  parseJwt = (token) => {
    var base64Url = token.split(".")[1];
    if (base64Url) {
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    }
    return;
  };

  tokenValidity() {
    axios
      .post(`${process.env.REACT_APP_TOKEN_VALIDITY}`, null, {
        headers: { Authorization: `${localStorage.getItem("isloggedIn")}` },
      })
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          // console.info(">>> token is valid");
        } else {
          // console.info(">>> token is invalid");
          this.props.logout();
        }
      })
      .catch((err) => {
        console.log(err);
        this.props.logout();
      });
  }

  render() {
    return (
      <React.Fragment>
        {!this.state.isAutoLogin ?
          <>
            <Header></Header>
            <Sidebar role={this.props.auth}></Sidebar>
            <div className="main-panel p-light-white">{this.props.children}</div> </> :
          <div className="container p-5">
            <div className="row">
              <div className="col-lg-5 offset-lg-3 col-10 offset-1 w3-white w3-card ">
                <div className="row">
                  <div className="col-lg-12 p-5">
                    <Dimmer active inverted>
                      <Loader content={this.state.autoLoginText} />
                    </Dimmer>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    permissions: (role, token) => dispatch(permissions(role, token)),
    autoLogin: (token, userKey) => dispatch(autoLogin(token, userKey))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
